export default "__VITE_ASSET__CReIyuIV__"